module.exports = __webpack_public_path__ + "img/sample-stack.1f1bc71f.png";